import React from 'react';

const Footer = () => <div>Footer</div>;

export default Footer;
